import React, {Component} from 'react';
import {Switch, Route} from 'react-router-dom';
import Start from './Start';
import Party from './Party';
import newFeesie from './newFeesie';
import joinFeesie from './joinFeesie';

class Main extends Component {

  render() {
    return <main>
      <Switch>
        <Route exact path='/' component={Start}/>
        <Route path='/party' component={Party}/>
        <Route exact path='/start/new' component={newFeesie}/>
        <Route exact path='/start/join' component={joinFeesie}/>
      </Switch>
    </main>
  }
}
export default Main;



// WEBPACK FOOTER //
// ./src/Main.js